import { post, get, baseURL } from "@/utils/request";


export const groupGames = (params: any) => post(`/v1/mgame/getGameList?pageNum=${params.pageNum}&pageSize=${params.pageSize}&groupId=${params.groupId}&groupType=${params.groupType}`);

export const groupGamesList = (params: any) => post(`/v1/mgame/getGameListByGroupId?pageNum=${params.pageNo}&pageSize=${params.pageSize}`, params);

export const getGameUrl = (data: any) => post(`/v1/mgame/login`, data);

export const getBetDetails = (data: any) => post(`/betLog/getBetDetails`, data);

export const gameListByGroup = (params: any) => post(`/v1/mgame/getGameListByGroup?pageNum=${params.pageNum}&pageSize=${params.pageSize}&groupId=${params.groupId}&type=${params.type}`, params);
